const educationData = [
    {
        degree: 'Bachelor of Technology in Computer Science',
        institution: 'IIIT Hyderabad',
        dates: '2019 - 2023',
        ta_list: ['Data Structures and Algorithm', 'Algorithms and Operating Systems'],
        courses: [ 'Software Engineering', 'Computer Vision', 'Advanced NLP', 'Distributed Systems', 'FPGA based Accelerator Design'],
    },
    {
        degree: 'Master of Science in Computer Science',
        institution: 'IIIT Hyderabad',
        dates: '2023 - 2024',
        ta_list: ['Advanced Computer Architecture'],
    },
];

export default educationData;
  